import { EntitiesStore } from './entities-store.abstract';
import { HttpClient } from '@angular/common/http';
import { of, merge } from 'rxjs';
import { CountryDependencyEntityStore } from './country-dependency-entity-store';
import { Injector } from '@angular/core';
import { mergeMap, tap, map, filter } from 'rxjs/operators';
import { environment } from '../../../../environments/environment.prod';


/**
 * Interface for member association data
 *
 * @export
 * @interface IMemberAssociation
 */
export interface IContinentalMemberAssociation {
  MaId: number;
  MaCode: string;
  MaName: string;
  NOC: string;
  CName: string;
  Founded: number;
  Affiliated: number;
  CShort: string;
  MaStatusCode: number;
  MaStatus: string;
  CaId: number;
  CaCode: string;
  CaName: string;
  Continent: string;
  Address: Address;
  Functions: MembersFunctionsItem[];
  Links: Links;
  Logo: Logo;
  Coordinates: Coordinates;
}
interface Coordinates {
  lat: number;
  long: number;
}
interface Address {
  Contact: string;
  Address: string;
  Zip: string;
  Place: string;
  State: string;
  CountryCode: string;
  ContryName: string;
  Notes: string;
  Latitude:number;
  Longitude:number;
}

interface MembersFunctionsItem {
  Id: number;
  Function: string;
  Title: string;
  FName: string;
  GName: string;
  WNameOrd: boolean;
}

interface Links {
  'E-Mail': string[];
  Mobile: string;
  Phone: string;
  Web: string;
}

interface Logo {
  URL: string;
  MimeType: string;
  Base64: string;
}


/**
 * Store fore getting the members stats
 *
 * @export
 * @class ContinentalIndividualAssociationStore
 * @extends {EntitiesStore<SeasonMembersStats>}
 */
export class ContinentalIndividualAssociationStore extends EntitiesStore<IContinentalMemberAssociation> {
  constructor(http: HttpClient, injector: Injector) {
    super('CONTINENTALASSOCIATION', http);
  }

  /**
   * Implementation for getting the coordinates calling to api
   *
   * @param {*} params
   * @param {boolean} request_more
   * @returns
   * @memberof ContinentalIndividualAssociationStore
   */
  getRequest(params: any, request_more: boolean) {
    if(params.Continent===undefined){
      return of([] as any);
    }
    return super.getRequest(params, request_more).pipe(tap(a=>{
      this.data = a.items.map(value=>Object.assign(value, {MaCode:value.CaCode, MaId:value.CaId, MaName:value.CaName}) );
      this.dataStream.next(this.data);
    }))
  }
}
